module.exports = __webpack_public_path__ + "static/media/bg-cartao@2x.5f2be189.png";